import { Metamodel } from 'app/model/base/model';
import { AmazonRdsSqlServerTableDataset } from 'app/model/dataset/amazon-rds-sql-server-table.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { SqlServerCopySource } from 'app/model/pipeline/copysource/sql-server.copysource';

@Metamodel.model({
    name: adfModelTypeMap.amazonRdsSqlServer.copySourceType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(AmazonRdsSqlServerTableDataset) }
})
export class AmazonRdsSqlServerCopySource extends SqlServerCopySource {
}
